import axios from "axios";
import { helpers } from "vuelidate/lib/validators";

export const formFiles = enabled => value => {
  if (enabled) {
    return value.length > 0;
  }
  return true;
};

export const phoneCheck = value =>
  !helpers.req(value) || /^0\d{10}$/.test(value);

export const NhsNumCheck = value =>
  !helpers.req(value) || /\d{10}$/.test(value);

export const MustBeYes = value => value === "Yes";

export const formMixin = {
  data() {
    return {
      isSuccess: false,
      isLoading: false,
      pageValidationMessage: false,
      altDate: null,
      form: {}
    };
  },
  methods: {
    getValue(event) {
      this.form[event.name] = event.value;
    },
    onFieldInput(event) {
      this.getValue(event);
    },
    onFieldFocus(event) {
      if (this.$v.form[event]) {
        this.$v.form[event].$reset();
        if (this.pageValidationMessage) {
          this.pageValidationMessage = false;
        }
      }
    },
    onMultiFieldInput(event) {
      this.getValue(event);
    },
    onDateSelect(event) {
      this.getValue(event);
      this.altDate = event.altValue;
    },
    onChange(event) {
      this.getValue(event);
      if (this.pageValidationMessage) {
        this.pageValidationMessage = false;
      }
    },
    onRadioChange(event) {
      this.getValue(event);
      if (this.pageValidationMessage) {
        this.pageValidationMessage = false;
      }
    },
    onCheckboxChange(event) {
      this.form[event.name] = event.checked;
      if (this.pageValidationMessage) {
        this.pageValidationMessage = false;
      }
    },
    onCheckboxGroupChange(event) {
      this.form[event.name] = event.strValue;
      if (this.pageValidationMessage) {
        this.pageValidationMessage = false;
      }
    },
    onSimpleCheckboxChange(event) {
      event.checked
        ? (this.form[event.name] = "Yes")
        : (this.form[event.name] = "No");
      if (this.pageValidationMessage) {
        this.pageValidationMessage = false;
      }
    },
    onRatingChange(event) {
      this.getValue(event);
      if (this.pageValidationMessage) {
        this.pageValidationMessage = false;
      }
    },
    medicationInput(event) {
      this.getValue(event);
      let num =
        event.name.substring(event.name.indexOf("_") + 1, event.name.length) -
        1;
      let name = event.name.substring(0, event.name.indexOf("_"));
      this.medicationList[num][name] = event.value;
      if (num == 1) {
        if (this.pageValidationMessage) {
          this.pageValidationMessage = false;
        }
      }
    },
    sendForm(data) {
      let requestData = data;
      requestData.practiceName = null;
      requestData.practiceTitle = null;
      requestData.practiceId = null;
      axios
        .post(this.submitUrl, requestData)
        .then(() => {
          this.isLoading = false;
          this.isSuccess = true;
          this.$emit("formSubmit");
        })
        .catch(e => {
          console.log(e);
        });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        this.pageValidationMessage = this.$v.form.$error;
        setTimeout(() => {
          this.scrollToQuery(".invalid-group");
        }, 100);
      } else {
        this.isLoading = true;
        this.sendForm(this.form);
      }
    },
    validate() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        this.pageValidationMessage = this.$v.form.$error;
        setTimeout(() => {
          this.scrollToQuery(".invalid-group");
        }, 100);
      } else {
        this.$refs.recaptcha.execute();
      }
    },
    onCaptchaPassed(token) {
      this.form.token = token;
      this.isLoading = true;
      this.sendForm(this.form);
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    }
  }
};
